<script>
	export let crumbs = [
		{
			name: 'Home',
			url: '/'
		}
	];
</script>

{#if crumbs && crumbs.length > 0}
	<div class="breadcrumb bg-dark-green">
		<div class="max-w-[120rem] px-[2rem] py-[1.5rem] mx-auto">
			<ul class="flex-1 text-white p-0">
				{#each crumbs as crumb, index}
					<li
						class="inline mr-[1rem] whitespace-nowrap {index + 1 < crumbs.length
							? " after:content-['/'] after:pl-[1rem]"
							: ''}"
					>
						{#if crumb.url}<a href="crumb.url">{crumb.name}</a>
						{:else}{crumb.name}{/if}
					</li>
				{/each}
			</ul>
		</div>
	</div>
{/if}
